<template>
  <el-dialog :visible.sync="dialogVisible"
             class="upload-file-dialog"
             width="640px"
             title="素材库"
             :center="true"
             @close="close">
    <div class="container">
      <el-tabs v-model="msg_type"
               tab-position="left"
               style="height: 350px;">

        <!-- ========================文件======================== -->
        <el-tab-pane label="文件"
                     name="files">
          <div class="right">
            <div class="right-top">
              <el-upload class="upload-btn"
                         action="/admin/upload/material-file"
                         accept=".pdf,.ppt,.pptx,.xlsx,.doc,.docx"
                         :data="uploadParams"
                         multiple
                         :show-file-list="false"
                         :before-upload="fileBeforeUpload('files')"
                         :on-progress="fileUploadIng('files')"
                         :on-success="fileUploadSuccess('files')"
                         :on-error="fileUploadError('files')">
                <el-button type="primary"
                           size="small">本地上传</el-button>
              </el-upload>
              <span class="tips">支持ppt、pdf、excel、word 格式文件，大小不超过 {{files.max_size | formatSize}}</span>
            </div>
            <div class="right-middle">
              <el-checkbox :indeterminate="files.isIndeterminate"
                           v-model="files.selectAll"
                           @change="selectAllFile($event,'files')">全选</el-checkbox>
              <p class="right-middle-desc">{{files.checkList.length}} / {{files.list.length}}</p>
            </div>
            <div class="right-bottom">
              <ul class="file-list file">
                <el-checkbox-group v-model="files.checkList"
                                   @change="selectFile($event,'files')">
                  <li v-for="(item,index) in files.list"
                      :key="index">
                    <template v-if="item.id>-1">
                      <el-checkbox :label="item.id">&nbsp;</el-checkbox>
                      <div class="file-item">
                        <div class="right-bottom-desc">
                          <icon-svg class="file-icon"
                                    :icon-class="item.type"></icon-svg>
                          <div class="file-desc">
                            <p class="file-name text-ellipsis">{{`${item.name}`}}</p>
                            <p class="file-size">{{item.size}}</p>
                          </div>
                        </div>
                        <el-button type="text"
                                   icon="el-icon-delete"
                                   @click.stop="delFile(item.id,'files',index)"></el-button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="file-uploading-wrap">
                        <el-progress :percentage="item.percentage"></el-progress>
                        <p class="item-desc">
                          <span class="item-name">{{item.name}}</span>
                          <span class="item-size">{{item.size}}</span>
                        </p>
                      </div>
                    </template>
                  </li>
                </el-checkbox-group>
              </ul>
            </div>
          </div>
        </el-tab-pane>

        <!-- ========================图片======================== -->
        <el-tab-pane label="图片"
                     name="images">
          <div class="right">
            <div class="right-top">
              <el-upload class="upload-btn"
                         action="/admin/upload/material-image"
                         accept=".png,.jpg,.gif"
                         :data="uploadParams"
                         multiple
                         :show-file-list="false"
                         :before-upload="fileBeforeUpload('images')"
                         :on-progress="fileUploadIng('images')"
                         :on-success="fileUploadSuccess('images')"
                         :on-error="fileUploadError('images')">
                <el-button type="primary"
                           size="small">本地上传</el-button>
              </el-upload>
              <span class="tips">支持上传 png、jpg、gif 格式，大小不超过 {{images.max_size | formatSize}}</span>
            </div>
            <div class="right-middle">
              <el-checkbox :indeterminate="images.isIndeterminate"
                           v-model="images.selectAll"
                           @change="selectAllFile($event,'images')">全选</el-checkbox>
              <p class="right-middle-desc">{{images.checkList.length}} / {{images.list.length}}</p>
            </div>
            <div class="right-bottom">
              <ul class="img-list">
                <li v-for="(item,index) in images.list"
                    :key="index"
                    :class="{checked: images.checkList.includes(item.id)}"
                    @click="selectImg(item.id,'images')">
                  <template v-if="item.id>-1">
                    <div class="img-container"
                         :style="{background: `url(${item.link}) center center / contain no-repeat #353535`}">
                      <div class="checked-tips">
                        <i class="el-icon-check icon-check"></i>
                      </div>
                      <div class="del-pic"
                           @click.stop="delFile(item.id,'images',index)">删除</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="img-uploading-wrap">
                      <el-progress type="circle"
                                   :width="50"
                                   :percentage="item.percentage"></el-progress>
                    </div>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>

        <!-- ========================音频======================== -->
        <el-tab-pane label="音频"
                     name="audios">
          <div class="right">
            <div class="right-top">
              <el-upload class="upload-btn"
                         action="/admin/upload/material-audio"
                         accept=".mp3"
                         :data="uploadParams"
                         multiple
                         :show-file-list="false"
                         :before-upload="fileBeforeUpload('audios')"
                         :on-progress="fileUploadIng('audios')"
                         :on-success="fileUploadSuccess('audios')"
                         :on-error="fileUploadError('audios')">
                <el-button type="primary"
                           size="small">本地上传</el-button>
              </el-upload>
              <span class="tips">仅支持上传mp3格式，大小不超过{{audios.max_size | formatSize}}</span>
            </div>
            <div class="right-middle">
              <el-checkbox :indeterminate="audios.isIndeterminate"
                           v-model="audios.selectAll"
                           @change="selectAllFile($event,'audios')">全选</el-checkbox>
              <p class="right-middle-desc">{{audios.checkList.length}} / {{audios.list.length}}</p>
            </div>
            <div class="right-bottom">
              <ul class="file-list file">
                <el-checkbox-group v-model="audios.checkList"
                                   @change="selectFile($event,'audios')">
                  <li v-for="(item,index) in audios.list"
                      :key="index">
                    <template v-if="item.id>-1">
                      <el-checkbox :label="item.id">&nbsp;</el-checkbox>
                      <div class="file-item">
                        <div class="right-bottom-desc">
                          <icon-svg class="file-icon"
                                    :icon-class="item.type"></icon-svg>
                          <div class="file-desc">
                            <p class="file-name text-ellipsis">{{item.name}}</p>
                            <p class="file-size">{{item.size}}</p>
                          </div>
                        </div>
                        <el-button type="text"
                                   icon="el-icon-delete"
                                   @click.stop="delFile(item.id,'audios',index)"></el-button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="file-uploading-wrap">
                        <el-progress :percentage="item.percentage"></el-progress>
                        <p class="item-desc">
                          <span class="item-name">{{item.name}}</span>
                          <span class="item-size">{{item.size}}</span>
                        </p>
                      </div>
                    </template>
                  </li>
                </el-checkbox-group>
              </ul>
            </div>
          </div>
        </el-tab-pane>

        <!-- ========================视频======================== -->
        <el-tab-pane label="视频"
                     name="videos">
          <div class="right">
            <div class="right-top">
              <el-upload class="upload-btn"
                         action="/admin/upload/material-video"
                         accept=".mp4"
                         :data="uploadParams"
                         multiple
                         :show-file-list="false"
                         :before-upload="fileBeforeUpload('videos')"
                         :on-progress="fileUploadIng('videos')"
                         :on-success="fileUploadSuccess('videos')"
                         :on-error="fileUploadError('videos')">
                <el-button type="primary"
                           size="small">本地上传</el-button>
              </el-upload>
              <span class="tips">仅支持上传mp4格式，大小不超过{{audios.max_size | formatSize}}</span>
            </div>
            <div class="right-middle">
              <el-checkbox :indeterminate="videos.isIndeterminate"
                           v-model="videos.selectAll"
                           @change="selectAllFile($event,'videos')">全选</el-checkbox>
              <p class="right-middle-desc">{{videos.checkList.length}} / {{videos.list.length}}</p>
            </div>
            <div class="right-bottom">
              <ul class="img-list">
                <li v-for="(item,index) in videos.list"
                    :key="index"
                    :class="{checked: videos.checkList.includes(item.id)}"
                    @click="selectImg(item.id,'videos')">
                  <template v-if="item.id>-1">
                    <div class="img-container"
                         :data-cover="item.video_cover"
                         :style="{background: `url(${item.video_cover}) center center / contain no-repeat #353535`}">
                      <div class="checked-tips">
                        <i class="el-icon-check icon-check"></i>
                      </div>
                      <div class="del-pic"
                           @click.stop="delFile(item.id,'videos',index)">删除</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="img-uploading-wrap">
                      <el-progress type="circle"
                                   :width="50"
                                   :percentage="item.percentage"></el-progress>
                    </div>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import util from '@/base/js/util'
import { _getMaterial, _delMaterial } from '@/api/live'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      msg_type: 'files',
      files: {
        max_size: 20 * 1024 * 1024,
        selectAll: false,
        isIndeterminate: false,
        list: [],
        checkList: []
      },
      images: {
        max_size: 2 * 1024 * 1024,
        selectAll: false,
        isIndeterminate: false,
        list: [],
        checkList: []
      },
      audios: {
        max_size: 50 * 1024 * 1024,
        selectAll: false,
        isIndeterminate: false,
        list: [],
        checkList: []
      },
      videos: {
        max_size: 1 * 1024 * 1024 * 1024,
        selectAll: false,
        isIndeterminate: false,
        list: [],
        checkList: []
      },
    }
  },
  computed: {
    uploadParams () {
      return {
        course_id: this.$route.params.id
      }
    }
  },
  created () {
    this.initList()
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    initList () {
      _getMaterial({
        params: this.uploadParams
      }).then(res => {
        this.files.list = res.result.files
        this.images.list = res.result.images
        this.audios.list = res.result.audios
        this.videos.list = res.result.videos
      })
    },
    selectAllFile (val, type) {
      this[type].checkList = val ? this[type].list.map(_ => _.id) : []
      this[type].isIndeterminate = false
    },
    selectFile (val, type) {
      let checkedCount = val.length
      this[type].selectAll = checkedCount === this[type].list.length
      this[type].isIndeterminate = checkedCount > 0 && checkedCount < this[type].list.length
    },
    delFile (id, type, index) {
      this.$confirm('你确定要删除此素材吗？', '提示', {
        conformButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _delMaterial({
          params: {
            id
          }
        }).then(res => {
          this[type].list.splice(index, 1)
        })
      }).catch(() => { })
    },
    selectImg (item, type) {
      if (this[type].checkList.includes(item)) {
        const index = this[type].checkList.indexOf(item)
        this[type].checkList.splice(index, 1)
      } else {
        this[type].checkList.push(item)
      }
      let checkedCount = this[type].checkList.length
      this[type].selectAll = checkedCount === this[type].list.length
      this[type].isIndeterminate = checkedCount > 0 && checkedCount < this[type].list.length
    },
    // ===================文件上传====================
    //选取文件钩子
    fileBeforeUpload (type) {
      return (file) => {
        if (file.size > this[type].max_size) {
          this.$message.error(`文件大小超过${util.formatSize(this[type].max_size)}限制`)
          return false
        }
        this[type].list.unshift({
          id: -1,
          name: file.name,
          size: util.formatSize(file.size),
          uid: file.uid,
          percentage: 0
        })
      }
    },
    //上传进度钩子
    fileUploadIng (type) {
      return (event, file) => {
        this[type].list.map(item => {
          if (item.uid && (file.uid == item.uid)) {
            item.percentage = ~~event.percent
          }
        })
      }
    },
    //上传成功钩子
    fileUploadSuccess (type) {
      return (res, file) => {
        this[type].list.map((item, i, list) => {
          if (item.uid && (file.uid == item.uid)) {
            if (res.resultCode == 1) {
              list.splice(i, 1, res.result)
            } else {
              this.$message.error(`${file.name}上传失败`)
              list.splice(i, 1)
            }
          }
        })
      }
    },
    //上传失败钩子
    fileUploadError (type) {
      return (err, file) => {
        console.log(err)
        this.$message.error(`${file.name}上传失败`)
        this[type].list.map((item, i, list) => {
          if (item.uid && (file.uid == item.uid)) {
            list.splice(i, 1)
          }
        })
      }
    }
  },
  filters: {
    formatSize (size) {
      return util.formatSize(size)
    }
  },
  watch: {
    visible (newVal) {
      this.dialogVisible = newVal
    }
  }
}
</script>

<style lang="less" scoped>
.right {
  height: 350px;
  overflow-y: auto;
}
.right-top {
  .upload-btn {
    display: inline-block;
    vertical-align: middle;
  }
  .tips {
    color: @gray;
    margin-left: 10px;
  }
}
.right-middle {
  margin: 24px 0;
  display: flex;
  align-items: center;
}
// 文件列表
.file-list {
  li {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .file-item {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    background-color: @table-bg;
    border-radius: 4px;
    margin-left: -32px;
  }
  .right-bottom-desc {
    display: flex;
    align-items: center;
  }
  .file-icon {
    width: 32px;
    height: 32px;
  }
  .file-desc {
    margin-left: 5px;
    font-size: 14px;
  }
  .file-name {
    max-width: 350px;
  }
  .file-size {
    margin-top: 5px;
    color: @gray;
  }
}
// 图片列表
.img-list {
  display: flex;
  flex-wrap: wrap;
  li {
    margin: 0 16px 16px 0;
    cursor: pointer;
    transform: all 0.3s;
    &.checked {
      .img-container {
        border-color: @blue;
        .checked-tips {
          display: block;
        }
      }
    }
    &:hover {
      .del-pic {
        height: 24px;
        visibility: visible;
      }
    }
  }
  .img-container {
    position: relative;
    width: 136px;
    height: 78px;
    font-size: 0;
    border: 1px solid transparent;
    overflow: hidden;
    .checked-tips {
      display: none;
      position: absolute;
      top: -7px;
      right: -17px;
      width: 46px;
      height: 26px;
      background-color: @blue;
      text-align: center;
      transform: rotate(45deg);
      .icon-check {
        font-size: 14px;
        margin-top: 12px;
        color: #ffffff;
        transform: rotate(-45deg);
      }
    }
    .del-pic {
      height: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      font-size: 14px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      cursor: pointer;
      transition: 0.3s height;
      visibility: hidden;
    }
  }
}
.file-uploading-wrap {
  padding: 10px;
  background-color: #ccc;
  border-radius: 4px;
  width: 100%;
  .item-desc {
    margin-top: 10px;
    font-size: 14px;
  }
  .item-size {
    margin-left: 10px;
  }
}
.img-uploading-wrap {
  width: 136px;
  height: 78px;
  background-color: #353535;
  border: 1px solid transparent;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="less">
.upload-file-dialog {
  .el-dialog--center .el-dialog__body {
    padding-bottom: 0;
    padding-top: 10px;
  }
}
</style>

